// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","365":"cb355538","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"6cea369d0f20a224c072","365":"232c6403febb6fc20940","532":"6bd1f7586d9fc4dc2d4e","678":"17bedb253d89a2cef19f","883":"6239ec1bf9c4097896b6"}[chunkId] + ".js";
};